import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';

import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Position } from '@xyflow/react';
import ActionHandle from '../ActionHandle';
import { ActionSwitchLanguageNodeType } from '../types';
import BaseNode from '../BaseNode';

export const ActionSwitchLanguageNode = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: ActionSwitchLanguageNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Switch Language',
              id: '+Ez+iF',
            })}
          </T>
          <T body2>
            {data.options.targetLanguage ||
              intl.formatMessage({
                defaultMessage: 'Target Language',
                id: 'NU4hHH',
              })}
          </T>
        </Flex>
        <ActionHandle
          type="target"
          position={Position.Left}
          disabled={disabled}
        />
        <ActionHandle
          type="source"
          position={Position.Right}
          disabled={disabled}
        />
      </BaseNode>
    );
  },
);
